import React from "react"
import { AiGlobalStats } from "../types/ai-dashboard"

interface Props {
     stats: AiGlobalStats
     isLoading: boolean // Added
}

const TokenBreakdownCard: React.FC<Props> = ({ stats, isLoading }) => {
     // Security anti-NaN
     const getPct = (val: number) => {
          if (!stats.totalTokens || stats.totalTokens <= 0) return "0.0"
          return ((val / stats.totalTokens) * 100).toFixed(1)
     }

     const ProgressSection = ({ label, value, color, textColor = "" }: { label: string; value: number; color: string; textColor?: string }) => (
          <div className="mb-4">
               <div className="d-flex justify-content-between mb-2 small">
                    <span className={textColor || "text-muted"}>{label}</span>
                    {isLoading ? <span className="placeholder col-2 rounded"></span> : <span className={`fw-bold ${textColor}`}>{getPct(value)}%</span>}
               </div>
               <div className="progress" style={{ height: "8px" }}>
                    <div className={`progress-bar bg-${color}`} style={{ width: isLoading ? "0%" : `${getPct(value)}%` }}></div>
               </div>
          </div>
     )

     return (
          <div className="card border-0 shadow-sm h-100">
               <div className="card-body p-4">
                    <h5 className="card-title mb-4 fw-bold">Analyse du Mix Token</h5>

                    <ProgressSection label="Input Normal (Plein tarif)" value={stats.inputNormal} color="primary" />
                    <ProgressSection label="Cached (Remise 50%)" value={stats.cachedTokens} color="success" textColor="text-success" />
                    <ProgressSection label="Output (Réponse IA)" value={stats.outputTokens} color="info" textColor="text-info" />

                    <div className="mt-4 p-3 bg-light rounded">
                         <p className="small text-muted mb-0 italic">
                              <i className="bi bi-info-circle me-1"></i>
                              Note : L'output coûte 4x plus cher que l'input normal.
                         </p>
                    </div>
               </div>
          </div>
     )
}

export default TokenBreakdownCard
